export default {"src":"/_next/static/media/mx-sol-icon1.1870c08b.svg","height":30,"width":36};